const url = process.env.REACT_APP_API_URL + '/api';
import { showToast } from '@jobber/components/Toast';
import { goToJobberSettings, isJobberAuthRequired } from '../../utils/jobber-auth-navigation';

const handleErrors = async (response) => {
	if (response.status == 401) {
		showToast({ message: 'Session expires. Login again to continue', variation: 'info' });
		window.location.href = '/login';
	} else if (response.status == 424) {
		const result = await response.json();
		if (isJobberAuthRequired(result)) goToJobberSettings();
		return result;
	} else {
		const result = await response.json();
		if (isJobberAuthRequired(result)) goToJobberSettings();
		return result;
	}
};

// All authenticated requests use credentials: 'include' to send cookies
const authHeaders = () => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('Accept', '*/*');
	return headers;
};

// --------------- post request (no auth) ---------------
const postToServerNoToken = async (urlPath, body = {}) => {
	var requestOptions = {
		method: 'POST',
		headers: authHeaders(),
		body: JSON.stringify(body),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, message: 'Connection Error' };
	}
};

// --------------- get request (no auth) ---------------
const getFromServerNoToken = async (urlPath) => {
	var requestOptions = {
		method: 'GET',
		headers: authHeaders(),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, data: {} };
	}
};

// --------------- post request ---------------
const postToServer = async (urlPath, body = {}) => {
	var requestOptions = {
		method: 'POST',
		headers: authHeaders(),
		body: JSON.stringify(body),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, message: `Error occured: ${error.message}` };
	}
};

// --------------- put request ---------------
const putToServer = async (urlPath, body = {}) => {
	var requestOptions = {
		method: 'PUT',
		headers: authHeaders(),
		body: JSON.stringify(body),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, data: {} };
	}
};

// --------------- patch request ---------------
const patchToServer = async (urlPath, body = {}) => {
	var requestOptions = {
		method: 'PATCH',
		headers: authHeaders(),
		body: JSON.stringify(body),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, data: {} };
	}
};

// --------------- delete request ---------------
const deleteFromServer = async (urlPath) => {
	var requestOptions = {
		method: 'DELETE',
		headers: authHeaders(),
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await handleErrors(response);
		return result;
	} catch (error) {
		return { status: false, message: `Error occured: ${error.message}` };
	}
};

// --------------- get request ---------------
const getFromServer = async (urlPath, signal) => {
	const response = await fetch(`${url}/${urlPath}`, {
		method: "GET",
		signal,
		headers: {
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		credentials: 'include'
	});

	if (!response.ok) {
		const result = await handleErrors(response);
		return result
	}

	if (urlPath == 'notifications') {
		const result = response.json();
		return result;
	} else {
		const result = await handleErrors(response);
		return result;
	}
};

// --------------- form data request ---------------
const formdataToServer = async (urlPath, method, formData) => {
	const headers = new Headers();
	var requestOptions = {
		method: method,
		headers: headers,
		body: formData,
		credentials: 'include'
	};
	try {
		const response = await fetch(`${url}/${urlPath}`, requestOptions);
		const result = await response.json();
		return result;
	} catch (error) {
		return { status: false, data: {} };
	}
};

export {
	deleteFromServer,
	formdataToServer,
	getFromServer,
	getFromServerNoToken,
	patchToServer,
	postToServer,
	postToServerNoToken,
	putToServer,
};
